'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Custom Decorators


// Actions


// Util


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _milanoteForm = require('../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _authActions = require('../../authActions');

var _referrerService = require('../../../user/account/referral/referrerService');

var _FullScreenMarketingModal = require('../../../components/modal/marketingModalPage/FullScreenMarketingModal');

var _FullScreenMarketingModal2 = _interopRequireDefault(_FullScreenMarketingModal);

var _PasswordInput = require('../../../components/form/fields/PasswordInput');

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _Form = require('../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FormInput = require('../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _StaticPageLink = require('../../../components/static/StaticPageLink');

var _StaticPageLink2 = _interopRequireDefault(_StaticPageLink);

var _PrimaryErrorMessage = require('../../../components/form/messages/PrimaryErrorMessage');

var _PrimaryErrorMessage2 = _interopRequireDefault(_PrimaryErrorMessage);

var _RegisterHeader = require('./RegisterHeader');

var _RegisterHeader2 = _interopRequireDefault(_RegisterHeader);

require('./Register.scss');

var _staticPageConstants = require('../../../components/static/staticPageConstants');

var _registerFormConstants = require('./registerFormConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getMarketingReferralCode = function getMarketingReferralCode(state) {
    var query = state.get('routing').locationBeforeTransitions.query;

    return query.r || query.ref;
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        inviteCode: state.get('routing').locationBeforeTransitions.query.invite,
        marketingReferralCode: getMarketingReferralCode(state)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit: function onSubmit(values) {
            return dispatch((0, _authActions.register)(values));
        },
        fetchInviteInformation: function fetchInviteInformation() {
            return dispatch((0, _authActions.fetchInvite)());
        }
    };
};

var mapStateToForm = function mapStateToForm(state) {
    return {
        initialValues: {
            inviteCode: state.get('routing').locationBeforeTransitions.query.invite,
            referrerCode: (0, _referrerService.getReferrer)(),
            marketingReferralCode: getMarketingReferralCode(state)
        }
    };
};

var Register = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({ form: _registerFormConstants.REGISTER_FORM_NAME, fieldsConfig: _registerFormConstants.REGISTER_FORM_FIELDS }, mapStateToForm), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(Register, _React$Component);

    function Register() {
        _classCallCheck(this, Register);

        return _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).apply(this, arguments));
    }

    _createClass(Register, [{
        key: 'componentDidMount',

        /**
         * Focuses the email input field when the page loads.
         */
        value: function componentDidMount() {
            this.refs.givenName.focus();

            if (this.props.inviteCode) this.props.fetchInviteInformation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                submitInterceptor = _props.submitInterceptor,
                sanitisedErrors = _props.sanitisedErrors,
                submitting = _props.submitting,
                showingErrors = _props.showingErrors,
                primaryError = _props.primaryError,
                dirtySinceSubmission = _props.dirtySinceSubmission;


            return _react2.default.createElement(
                _FullScreenMarketingModal2.default,
                {
                    className: 'Register',
                    header: _react2.default.createElement(_RegisterHeader2.default, this.props),
                    background: require('./register-bg.jpg') },
                _react2.default.createElement(
                    'div',
                    { className: 'heading' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Create your account'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        _Form2.default,
                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }),
                            onSubmit: submitInterceptor,
                            noValidate: true },
                        _react2.default.createElement('input', { id: 'pwd', className: 'fake-password', tabIndex: '-1', 'aria-hidden': 'true', type: 'password',
                            name: 'fakepasswordremembered' }),
                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { name: _registerFormConstants.REGISTER_FORM_FIELDS.inviteCode.name, type: 'hidden' })),
                        _react2.default.createElement(_FormInput2.default, _extends({}, this.props, {
                            name: _registerFormConstants.REGISTER_FORM_FIELDS.marketingReferralCode.name, type: 'hidden' })),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'givenName' },
                                    'Your name'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.givenName }),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.familyName })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'field' },
                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'givenName',
                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.name,
                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.type,
                                        placeholder: 'First name',
                                        maxLength: _registerFormConstants.REGISTER_FORM_FIELDS.givenName.maxLength }))
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'field' },
                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'familyName',
                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.name,
                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.type,
                                        placeholder: 'Last name',
                                        maxLength: _registerFormConstants.REGISTER_FORM_FIELDS.familyName.maxLength }))
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'email' },
                                    'Your email'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'field' },
                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, {
                                        name: _registerFormConstants.REGISTER_FORM_FIELDS.email.name,
                                        type: _registerFormConstants.REGISTER_FORM_FIELDS.email.type }))
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'password' },
                                    'Choose a password'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.password })
                            ),
                            _react2.default.createElement(_PasswordInput2.default, _extends({}, this.props, {
                                name: _registerFormConstants.REGISTER_FORM_FIELDS.password.name,
                                canShowPassword: true }))
                        ),
                        _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.inviteCode }),
                        _react2.default.createElement(
                            _FormButton2.default,
                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
                            'Register'
                        ),
                        _react2.default.createElement(_PrimaryErrorMessage2.default, { message: primaryError && primaryError.message,
                            show: !!primaryError && !dirtySinceSubmission && !submitting }),
                        _react2.default.createElement(
                            'div',
                            { className: 'disclaimer' },
                            'By proceeding to create your account and use Milanote, you are agreeing to our\xA0',
                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.termsOfService }),
                            '\xA0and our\xA0',
                            _react2.default.createElement(_StaticPageLink2.default, { config: _staticPageConstants.STATIC_PAGE.privacyPolicy })
                        )
                    )
                )
            );
        }
    }]);

    return Register;
}(_react2.default.Component)) || _class) || _class);
exports.default = Register;


Register.propTypes = {
    navigateToStaticPage: _propTypes2.default.func,
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object,
    inviteCode: _propTypes2.default.string,
    marketingReferralCode: _propTypes2.default.string,
    fetchInviteInformation: _propTypes2.default.func,
    primaryError: _propTypes2.default.object,
    dirtySinceSubmission: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/register/Register.js
// module id = 1684
// module chunks = 0